module.exports = __webpack_public_path__ + "static/img/logo.882e3f99.png";